import api from '@/lib/api/axios'

export interface Scheduler {
    id: number
    schedulerId: string
    description: string
    locationId: number | null
    locationName: string
    ipAddress: string | null
    status: 'Pending' | 'Active' | 'Revoked'
    lastSeen: string | null
    totalUploads: number
    created: string
    registered: string | null
    hasMachineFingerprint: boolean
    tokenExpired: boolean
}

export interface SchedulerDetail extends Scheduler {
    externalId: string | null
    machineFingerprint: string | null
}

export interface CreateSchedulerResponse {
    schedulerId: string
    registrationToken: string
    tokenExpiry: string
}

export const schedulerApi = {
    list: () =>
        api.get('/api/schedulers'),

    get: (id: number) =>
        api.get(`/api/schedulers/${id}`),

    getLocations: () =>
        api.get('/api/schedulers/locations'),

    create: (data: { locationId?: number; description?: string }) =>
        api.post('/api/schedulers', data),

    revoke: (id: number) =>
        api.post(`/api/schedulers/${id}/revoke`),

    regenerateToken: (id: number) =>
        api.post(`/api/schedulers/${id}/regenerate-token`),
}
